module.exports = __webpack_public_path__ + "static/media/Evie Thompson Headshot_1679721891147.e46884e1.jpeg";